import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import Card from '@material-ui/core/Card'
import Loading from '../widgets/Loading'
import SecurityAnswer from '../widgets/userProfile/SecurityAnswer'
import EmailAddress from '../widgets/userProfile/EmailAddress'
import ChangePassword from '../widgets/userProfile/ChangePassword'
import Banking from '../widgets/userProfile/Banking'
import TitledLabel from '../controls/TitledLabel'
import NgrxAuth from '../auth/Auth'
import { connect } from 'react-redux'
import { logout } from '../redux/actions/logoutActions'
import { fetchUser, updateUser } from '../redux/actions/userProfileActions'
import { toggleLanguage } from '../redux/actions/languageActions'
import { injectIntl } from 'react-intl'
import NotificationSystem from 'react-notification-system'
import NotificationStyles from '../styles/components/react-notification-system'
import Config from '../Config'

class UserProfile extends Component {
  constructor () {
    super()
    this.addNotification = this.addNotification.bind(this)
    this.state = {
      securityQuestions: [],
      securityQuestion: '',
      securityAnswer: ''
    }
    this.notificationSystem = React.createRef()
  }

  componentDidMount () {
    this.props.fetchUser()
  }

  static getDerivedStateFromProps (props, state) {
    // so here since the user props get updated by redux, we need to set it into the state
    // so the UI updates
    if (props.user !== null) {
      return {
        securityQuestions: props.user.securityQuestions,
        securityQuestion: props.user.securityQuestion,
        securityAnswer: props.user.securityAnswer
      }
    }
    // just return null as the default
    return null
  }

  onProfileUpdateError = (data) => this.addNotification(data.message, data.friendlyCode)

  onProfileUpdateSuccess = () => this.addNotification(localize('pages.userProfile.snackbar.message'), undefined, 'success')

  onBankingUpdateSuccess = () => this.addNotification(localize('pages.userProfile.banking.updated'), undefined, 'success')

  handlePanelExpandedChanged = panelKey => (expanded) => this.setState({ expandedKey: expanded ? panelKey : false })

  addNotification = (title, message, level = 'error', autoDismiss = 5) => {
    const notification = this.notificationSystem.current
    if (!notification) { return }
    notification.clearNotifications()

    const options = {
      title,
      message,
      level,
      position: 'tc',
      autoDismiss
    }
    notification.addNotification(options)
  }

  render () {
    return (
      <div className='userProfilePage pageContent'>
        <Header />
        <NotificationSystem ref={this.notificationSystem} style={NotificationStyles} />
        {!this.props.user
          ? <section className='userProfileContent mainContent'>
            <Loading message={localize('common.loadingContent')} />
          </section>

          : <section className='mainContent'>
            <Grid fluid>
              <Row className='userProfileContent' center='xs'>
                <Col xs={12} md={10} lg={9} style={{ textAlign: 'left' }}>
                  {/* Page Section title */}
                  <Row>
                    <Col xs={12}>
                      <h2>{localize('pages.userProfile.title')}</h2>
                    </Col>
                  </Row>

                  {/* User Info */}
                  <Row>
                    <Col xs={12}>
                      <div className='userNameCerti'>
                        <p className='bold'>{NgrxAuth.name}</p>
                        <p>{localize('common.certiNum')}: {this.props.profileInfo.certificateNumber}</p>
                      </div>
                    </Col>
                  </Row>
                  {/* User Information section heading */}
                  <Row>
                    <Col xs={12}>
                      <h3 className='sectionHeading'>{localize('pages.userProfile.sectionHeading')}</h3>
                    </Col>
                  </Row>
                  {/* User profile form */}
                  <Card className='cardStandard userInfoCard'>
                    {this.props.pageLoading || !this.props.user ? (
                      <Loading message={localize('common.loadingContent')} />
                    ) : (
                      <div>
                        <Row className='userInfo'>
                          <Col xs={12}>
                            <TitledLabel title={localize('pages.userProfile.username')} value={this.props.user.username} />
                          </Col>
                          <Col xs={12}>
                            <TitledLabel title={localize('pages.userProfile.email')} value={this.props.user.email} />
                          </Col>
                          <Col xs={12}>
                            {(!Config.hideEmailSection) && (
                              <EmailAddress
                                isProfile={true}
                                showMuiBorder={false}
                                username={this.props.user.username}
                                saveComplete={(data) => this.onProfileUpdateSuccess(data)}
                                errorOnSave={(data) => this.onProfileUpdateError(data)}
                                expanded={this.state.expandedKey === 'email'}
                                onExpanded={this.handlePanelExpandedChanged('email')}
                              />)}
                            {(!Config.hidePasswordSection) && (
                              <ChangePassword
                                isProfile={true}
                                showMuiBorder={false}
                                username={this.props.user.username}
                                saveComplete={(data) => this.onProfileUpdateSuccess(data)}
                                errorOnSave={(data) => this.onProfileUpdateError(data)}
                                expanded={this.state.expandedKey === 'pwd'}
                                onExpanded={this.handlePanelExpandedChanged('pwd')}
                              />)}
                            {(!Config.hideSecurityQuestionsSection) && (
                              <SecurityAnswer
                                isProfile={true}
                                showMuiBorder={false}
                                certificateNumber={this.props.user.certificateNumber}
                                email={this.props.user.email}
                                username={this.props.user.username}
                                securityQuestions={this.state.securityQuestions}
                                securityQuestion={this.state.securityQuestion}
                                securityAnswer={this.state.securityAnswer}
                                saveComplete={(data) => this.onProfileUpdateSuccess(data)}
                                errorOnSave={(data) => this.onProfileUpdateError(data)}
                                expanded={this.state.expandedKey === 'sec'}
                                onExpanded={this.handlePanelExpandedChanged('sec')}
                              />)}
                            {!Config.hideBankingInfoSection && <Banking
                              isProfile={true}
                              showMuiBorder={false}
                              saveComplete={(data) => this.onBankingUpdateSuccess(data)}
                              errorOnSave={(data) => this.onProfileUpdateError(data)}
                              expanded={this.state.expandedKey === 'banking'}
                              onExpanded={this.handlePanelExpandedChanged('banking')} />}
                          </Col>
                        </Row>
                      </div>
                    )
                    }
                  </Card>
                </Col>
              </Row>
            </Grid>
            <Footer />
          </section>}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.UserProfileReducers.user,
    userResponse: state.UserProfileReducers.userResponse,
    pageLoading: state.isFetching,
    profileInfo: state.UserProfileReducers.user,
    error: state.UserProfileReducers.error,
    success: state.UserProfileReducers.success,
    bankingSuccess: state.UserProfileReducers.bankingSuccess
  }
}

const ConnectedUserProfile = connect(mapStateToProps, {
  logout,
  toggleLanguage,
  fetchUser,
  updateUser
})(injectIntl(UserProfile))

export default ConnectedUserProfile

export const buildTitle = (title, subtitle) => {
  return (
    <span className='collapseSubtitle'>
      <span className='title'>{localize(title)}</span>
      <small>{localize(subtitle)}</small>
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/UserProfile.js